import { render } from "./ToastComp.vue?vue&type=template&id=b9f55c2a&scoped=true"
import script from "./ToastComp.vue?vue&type=script&lang=js"
export * from "./ToastComp.vue?vue&type=script&lang=js"

import "./ToastComp.vue?vue&type=style&index=0&id=b9f55c2a&lang=less&scoped=true"
import "./ToastComp.vue?vue&type=style&index=1&id=b9f55c2a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9f55c2a"]])

export default __exports__